import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { SalesHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/SalesHubFaqs';
import { SalesHubProductIcon } from 'pricing-pages-ui-components/productIcon/SalesHubProductIcons';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackPageView } from '../../utils/tracking/trackingEventUtils';
import { SalesHubFeatureTable } from './SalesHubFeatureTable';
import { SalesHubMerchCards } from './SalesHubMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SALES_HUB_API_NAMES = [Products.SALES_HUB_STARTER, Products.SALES_HUB_PROFESSIONAL, Products.SALES_HUB_ENTERPRISE];
export const SalesHubPage = () => {
  useDocumentTitle('sales');
  useEffect(() => {
    trackPageView({
      screen: 'sales'
    });
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "SALES_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SALES",
      apiNames: SALES_HUB_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsxs(PageTitle, {
        "aria-level": 1,
        children: [/*#__PURE__*/_jsx(SalesHubProductIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.sales.pageTitle"
        })]
      }), /*#__PURE__*/_jsx(PageSubTitle, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.sales.description"
        })
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(SalesHubMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "sales"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(SalesHubFeatureTable, {})
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "sales"
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "1400",
      children: /*#__PURE__*/_jsx(SalesHubFaqs, {})
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "sales-footer",
      screen: "sales",
      apiName: Products.SALES_HUB_STARTER
    })]
  });
};